import { userAlerts as alerts, useAlert } from 'shared/components/alerts';
import { HqUser } from '@types';
import { routes } from 'Routes';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { Header, LwButton, Page, Toolbox } from 'redesign';
import { UserForm } from './user-form';
import { useUsersPage } from '../hooks/params/use-users';
import { useRolesMatrix } from '../hooks/query/use-roles-matrix';
import { RenderUnsettledUI } from '../../../../../shared/components';
import { RoleMatrix } from '../../../../services/userService';
import { useCreateUser } from '../hooks/query/use-create-user';

export type HqUserFormContext = {
  id: string;
  firstName: string;
  lastName: string;
  email?: string;
  companyId?: string;
  nickname?: string;
  roles?: HqUser['roles'];
};

export const UserCreate = () => {
  const rolesMatrixQuery = useRolesMatrix();

  if (rolesMatrixQuery.status !== 'success') {
    return <RenderUnsettledUI data={rolesMatrixQuery} />;
  }

  return <UserCreateImpl roleMatrix={rolesMatrixQuery.data} />;
};

const UserCreateImpl = ({ roleMatrix }: { roleMatrix: RoleMatrix[] }) => {
  const methods = useForm<HqUserFormContext>();
  const { alertSuccess, alertError } = useAlert();
  const generatePath = useHqRelativePath();
  const navigate = useNavigate();
  const { filters } = useUsersPage();
  const createUser = useCreateUser();

  const onSubmit = () => {
    methods.handleSubmit((data: HqUser) => {
      createUser.mutate(data, {
        onSuccess: () => {
          alertSuccess(alerts.success.created);
          navigate(generatePath(routes.HQUsers, undefined, filters));
        },
        onError: (e) => alertError(e),
      });
    })();
  };

  const onCancel = () => navigate(-1);

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <Page
          header={<Header titleText="Nieuwe gebruiker aanmaken" />}
          toolbox={
            <Toolbox>
              <LwButton onClick={onSubmit}>Akkoord</LwButton>
              <LwButton color="secondary" onClick={onCancel}>
                Annuleer
              </LwButton>
            </Toolbox>
          }
        >
          <UserForm state={'create'} roleMatrix={roleMatrix} />
        </Page>
      </form>
    </FormProvider>
  );
};
